import { requireCompany } from "../../editor/core/helpers/company-provider";
import { BlockGroup, BlockSource, type BlockItem } from "../types/block-item.types";

const uid8 = () => {
    const u = crypto?.randomUUID?.();
    if (u) return u.replace(/-/g, "").slice(0, 8);
    return (Math.random().toString(36).slice(2) + Date.now().toString(36)).slice(0, 8);
};

type BlockHelpers = {
    company: () => { companyId: string; companySlug: string, coverageAreas: any[] };
};

const helpers: BlockHelpers = {
    company: () => requireCompany(),
};



export const withUniqueClass =
    (prefix: string, html: (cls: string, h: BlockHelpers) => string) =>
        () =>
            html(`${prefix}-${uid8()}`, helpers);

// BASIC (global)
export const basic = {
    input: (def: Omit<BlockItem, "source" | "group" | "templateId">): BlockItem => ({
        ...def,
        source: BlockSource.BASIC,
        group: BlockGroup.INPUTS,
    }),
    section: (def: Omit<BlockItem, "source" | "group" | "templateId">): BlockItem => ({
        ...def,
        source: BlockSource.BASIC,
        group: BlockGroup.SECTIONS,
    }),
    module: (def: Omit<BlockItem, "source" | "group" | "templateId">): BlockItem => ({
        ...def,
        source: BlockSource.BASIC,
        group: BlockGroup.MODULES,
    }),
};

// CUSTOM (por plantilla | template)
export const custom = (templateId: string) => ({
    input: (def: Omit<BlockItem, "source" | "group" | "templateId">): BlockItem => ({
        ...def,
        source: BlockSource.CUSTOM,
        templateId,
        group: BlockGroup.INPUTS,
    }),
    section: (def: Omit<BlockItem, "source" | "group" | "templateId">): BlockItem => ({
        ...def,
        source: BlockSource.CUSTOM,
        templateId,
        group: BlockGroup.SECTIONS,
    }),
    module: (def: Omit<BlockItem, "source" | "group" | "templateId">): BlockItem => ({
        ...def,
        source: BlockSource.CUSTOM,
        templateId,
        group: BlockGroup.MODULES,
    }),
});